export const WorkerActions = {
  TOGGLE_LOADER: '@WorkerActions/TOGGLE_LOADER',
  TOGGLE_ERROR: '@WorkerActions/TOGGLE_ERROR',
  UPDATE_DATA: '@WorkerActions/UPDATE_DATA',
  SET_AVAILABLE_PLANS: '@WorkerActions/SET_AVAILABLE_PLANS',
};

const workerState = {
  isLoading: false,
  isError: false,
  workerData: {
    ativo: 0,
    cargo: '',
    data_alteracao: '',
    data_inclusao: '',
    email: '',
    foto: '',
    id_colaborador: '',
    id_empresa: '',
    id_setor: '',
    nome: '',
    saldo_moedas: 0,
    senha: '',
    seq: 0,
    telefone: '',
  },
  pnfamData: {
    cervical: 0,
    centro_costas: 0,
    lombar: 0,
    peitoral: 0,
    ombro_esquerdo: 0,
    ombro_direito: 0,
    perna_esquerda: 0,
    perna_direita: 0,
    pe_esquerdo: 0,
    pe_direito: 0,
    punho_esquerdo: 0,
    punho_direito: 0,
    desconforto_fisico: '',
    dor_constante: '',
    nota_postura: 0,
    cansaco_fisico: 0,
    ansiedade: 0,
    qualidade_sono: 0,
    dor_cabeca: 0,
  },
  classesData: [],
  planData: undefined,
  availablePlans: [],
};

const WorkerReducer = (state = workerState, action) => {
  switch (action.type) {
    case WorkerActions.TOGGLE_LOADER: return { ...state, isLoading: !state.isLoading };
    case WorkerActions.UPDATE_DATA: return { ...state, [action.dataType]: action.dataValue };
    case WorkerActions.SET_AVAILABLE_PLANS: return { ...state, availablePlans: action.availablePlans };
    case WorkerActions.TOGGLE_ERROR: return { ...state, isError: !state.isError };
    default: return { ...state };
  }
};

export default WorkerReducer;
